import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-repair-equipment',
  templateUrl: './repair-equipment.component.html',
  styleUrls: ['./repair-equipment.component.scss']
})
export class RepairEquipmentComponent implements OnInit {

  constructor(private title: Title) { }

  ngOnInit() {
    this.title.setTitle('Reparación - CCCISA');
  }

}
